<div>
    <div class="pipeline-map-dashboard"
         [ngStyle]="{'background-image': 'linear-gradient(to right, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0)), url(' + thumbnailImgPath + ')'}">
        <div class="header">
            Pipeline Map
        </div>
        @if(!(excludeInfoPostMap$ | async)){
        <i class="icon-download"
           type="secondary"
           size="small"
           (click)="downloadDocument()"></i>
        }
    </div>
</div>